<template>
  <div class="sb_svg-icon">
    <svg role="img">
      <use :xlink:href="'#' + iconId" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconId: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.sb_svg-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: none;
  transform-origin: 50% 50%;

  svg {
    width: 1em;
    height: 1em;
    fill: currentcolor;
  }

  &.s_fill-red {
    color: $brand-vibe-red;
  }

  &.s_fill-green {
    color: $brand-vibe-green;
  }

  &.s_fill-primary {
    color: $brand-primary;
  }
}
</style>
